"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = void 0;
class Provider {
    constructor(props) {
        this.address = props?.address;
        this.banned = props?.banned;
        this.country = props?.country;
        this.cuit = props?.cuit;
        this.dni = props?.dni;
        this.dob = props?.dob;
        this.doctorLogin = props?.doctorLogin;
        this.dt = props?.dt;
        this.email = props?.email;
        this.enable = props?.enable;
        this.especialidad = props?.especialidad;
        this.firstname = props?.firstname;
        this.fullname = props?.fullname;
        this.holidays = props?.holidays;
        this.lastname = props?.lastname;
        this.matricula = props?.matricula;
        this.matricula_especialidad = props?.matricula_especialidad;
        this.medikit_token = props?.medikit_token;
        this.metrics = props?.metrics;
        this.path_afip = props?.path_afip;
        this.path_cv = props?.path_cv;
        this.path_degree = props?.path_degree;
        this.path_dni = props?.path_dni;
        this.path_dni_back = props?.path_dni_back;
        this.path_dni_barcode = props?.path_dni_barcode;
        this.path_insurance = props?.path_insurance;
        this.path_matricula = props?.path_matricula;
        this.path_profile_pic = props?.path_profile_pic;
        this.profile_description = props?.profile_description;
        this.reverified = props?.reverified;
        this.rol = props?.rol;
        this.services = props?.services;
        this.sex = props?.sex;
        this.shifts = props?.shifts;
        this.signature = props?.signature;
        this.social_work = props?.social_work;
        this.uid = props?.uid;
        this.university = props?.university;
        this.verified = props?.verified;
        this.ws = props?.ws;
        this.expireDni = props?.expireDni;
        this.expireInsurance = props?.expireInsurance;
        this.expireMatricula = props?.expireMatricula;
    }
}
exports.Provider = Provider;
